import { Popover } from '@headlessui/react';
import Link from 'next/link';
import * as React from 'react';
import { useRouter } from 'next/router';
import scrollToSection from '../helpers/scrollToSection';
import { AnimatePresence, motion } from 'framer-motion';
import { LANDING_PAGE_NAVBAR_LINKS } from '../constants/landingPageNavbarLinks';
import SvgIcon from './icons/SvgIcon';

function MobileNavLink({ children, href, ...props }) {
  return (
    <Popover.Button
      legacyBehavior={false}
      as={Link}
      className="block text-base leading-7 tracking-tight text-gray-700"
      href={href}
      {...props}
    >
      {children}
    </Popover.Button>
  );
}

export default function MobileNavHamburger() {
  const { route } = useRouter();
  const isOnHomePage = route === '/';

  return (
    <div className="flex items-center gap-6">
      <Popover className="lg:hidden">
        {({ open, close }) => (
          <>
            <Popover.Button
              className="relative z-10 -m-2 inline-flex items-center rounded-lg stroke-gray-900 p-2 hover:bg-gray-200/50 hover:stroke-gray-600 active:stroke-gray-900 [&:not(:focus-visible)]:focus:outline-none"
              aria-label="Toggle site navigation"
            >
              {({ open }) =>
                open ? (
                  <SvgIcon name={'HiChevronUp'} className="h-6 w-6" />
                ) : (
                  <SvgIcon name={'HiBars3'} className="h-6 w-6" />
                )
              }
            </Popover.Button>
            <AnimatePresence initial={false}>
              {open && (
                <>
                  <Popover.Overlay
                    static
                    as={motion.div}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-0 bg-gray-300/60 backdrop-blur"
                  />
                  <Popover.Panel
                    static
                    as={motion.div}
                    initial={{ opacity: 0, y: -32 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{
                      opacity: 0,
                      y: -32,
                      transition: { duration: 0.2 },
                    }}
                    className="absolute inset-x-0 top-0 z-0 origin-top rounded-b-2xl bg-gray-50 px-6 pb-6 pt-32 shadow-2xl shadow-gray-900/20"
                  >
                    <div className="space-y-4">
                      {isOnHomePage ? (
                        <div
                          className="block text-base leading-7 tracking-tight text-gray-700"
                          onClick={() => {
                            close();
                            scrollToSection('features');
                          }}
                        >
                          Features
                        </div>
                      ) : null}
                      {LANDING_PAGE_NAVBAR_LINKS.map(link => {
                        return (
                          <MobileNavLink href={link.href} key={link.href}>
                            {link.title}
                          </MobileNavLink>
                        );
                      })}
                    </div>
                    <div className="mt-8 flex flex-col gap-4">
                      <button
                        className="btn"
                        onClick={() => {
                          close();
                          scrollToSection('download');
                        }}
                      >
                        Download the app
                      </button>
                    </div>
                  </Popover.Panel>
                </>
              )}
            </AnimatePresence>
          </>
        )}
      </Popover>
    </div>
  );
}
